import { FC } from 'react';

export const IconTable: FC = () => (
  // eslint-disable-next-line react/forbid-elements
  <svg fill="none" height="40" width="40" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 20v17M13 37h14M5 38V18M35 38V18M39 17H1v-5h38v5z" stroke="#737A8E" strokeWidth="2" />
    <path
      d="M12 9a6 6 0 016-6h4a6 6 0 016 6v11H12V9zM12 24h16v1a3 3 0 01-3 3H15a3 3 0 01-3-3v-1z"
      fill="#fff"
      stroke="#737A8E"
      strokeWidth="2"
    />
  </svg>
);

IconTable.displayName = 'IconTable';
